
import styles from  "../styles/Header.module.css";



function Header() {
  return (
    <header className={styles.header}>
  
</header>

  );
}

export default Header;
